export { default as DriverWheelSvgIcon } from "../Images/Vector (29).svg";
export { default as MarkerSvgIcon } from "../Images/Vector (30).svg";
export { default as FlagSvgIcon } from "../Images/Vector 231.svg";
export { default as DotLogoSvgIcon } from "../Images/logo-white.svg";
export { default as SpeedSvgIcon } from "../Images/speedicon.svg";
export { default as UserIconSvg } from "../Images/user.svg";
export { default as AlgorithmSvgIcon } from "./alogrithm.svg";
export { default as CarSvgIcon } from "./car.svg";
export { default as DocumentSvgIcon } from "./document.svg";
export { default as HomeSvgIcon } from "./home.svg";
export { default as LightbulbSvgIcon } from "./lightbulb.svg";
export { default as SettingSvgIcon } from "./setting.svg";
export { default as TruckSvgIcon } from "./truck.svg";
export { default as UserSvgIcon } from "./user.svg";
export { default as LiveLocationSvg } from "./current-location-icon.svg";
export { default as AvailableDriver } from "./security.svg";
export { default as DriversOnJob } from "./line-circle.svg";
export { default as InactiveDrivers } from "./stop-circle.svg";
export { default as OfflineDrivers } from "./star.svg";
